import React, { useState, useEffect } from "react"
import { TextField, InputAdornment, IconButton, styled } from "@mui/material"
import { IoSearchOutline, IoCloseOutline } from "react-icons/io5"
import useDebounce from "../../../hooks/useDebounce"

const StyledTextField = styled(TextField)(({ theme }) => ({
  "& .MuiOutlinedInput-root": {
    backgroundColor: "#fafafa",
    borderRadius: "8px",
    height: "40px",
    minWidth: "300px",
    "& fieldset": {
      borderColor: "#e0e0e0",
      borderWidth: "1px",
    },
    "&:hover fieldset": {
      borderColor: "#bdbdbd",
    },
    "&.Mui-focused fieldset": {
      borderColor: theme.palette.primary.main,
      borderWidth: "2px",
    },
  },
  "& .MuiOutlinedInput-input": {
    padding: "8px 0px",
    fontSize: "14px",
    color: "#424242",
    "&::placeholder": {
      color: "#9e9e9e",
      opacity: 1,
    },
  },
}))

interface SearchBarProps {
  onSearch: (searchTerm: string) => void
  placeholder?: string
  debounceMs?: number
}

const SearchBar: React.FC<SearchBarProps> = ({
  onSearch,
  placeholder = "Search applications...",
  debounceMs = 400,
}) => {
  const [inputValue, setInputValue] = useState("")
  const debouncedValue = useDebounce(inputValue, debounceMs)

  useEffect(() => {
    onSearch(debouncedValue)
  }, [debouncedValue, onSearch])

  const handleClear = () => {
    setInputValue("")
  }

  return (
    <StyledTextField
      variant="outlined"
      placeholder={placeholder}
      value={inputValue}
      onChange={(e) => setInputValue(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <IoSearchOutline size={18} color="#757575" />
          </InputAdornment>
        ),
        endAdornment: inputValue && (
          <InputAdornment position="end">
            <IconButton
              onClick={handleClear}
              size="small"
              sx={{
                padding: "4px",
                "&:hover": {
                  backgroundColor: "#f5f5f5",
                },
              }}
            >
              <IoCloseOutline size={16} color="#757575" />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}

export default SearchBar


